import { Box, Button } from '@factorialco/deprecated-design-system'
import {
  ProjectionKind,
  useTrainingsCategoriesDataTable,
} from 'generated/resources/datatable.graphql'

import DataTable from 'modules/core/components/DataTable'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

export function CategoriesDataTable() {
  const { navigation } = useNavigation()
  const source = useTrainingsCategoriesDataTable([
    {
      identifier: 'name',
      kind: ProjectionKind.Path,
      title: i18n.t('trainings.tags.table.name_column'),
      path: 'name',
    },
    {
      identifier: 'actions',
      kind: ProjectionKind.Decorative,
      render: ({ id }) => {
        return (
          <Box flexDirection="row" justifyContent="flexEnd" alignItems="center" paddingRight="s64">
            {
              <Button.Router
                type="secondary"
                to={navigation.trainings.list.categories.deleteCategory.fullPath({
                  id: String(id),
                })}
                iconName="delete"
              />
            }
          </Box>
        )
      },
    },
  ])

  return (
    <DataTable.Provider source={source} sort={{ path: 'name', direction: 'asc' }}>
      <Box gap="s16">
        <DataTable.HeadBar
          exportFileName={i18n.t('trainings.tags.table.export_name')}
          actions={
            <Button.Router to={navigation.trainings.list.categories.new.fullPath()} iconName="add">
              {i18n.t('trainings.tags.table.add_button_label')}
            </Button.Router>
          }
        />
        <DataTable.Table />
      </Box>
    </DataTable.Provider>
  )
}
